<template>
    <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                           :titleLabel="$t('profile.label.additional_email')"
                           :parentScreen="parentScreen">
        <div class="form-group row">
            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.mail')}}</label>
            <div class="col-md-6">
                <input type="text"
                       class="form-control"
                       v-model="$v.input['amsCustomerDetail.additionalEmail'].$model"
                       name="additionalEmail"
                       required
                       maxlength="50"
                       v-remove-fullwidth-character
                       v-keep-only-character
                       @keyup="additionalEmailKeyUp()"
                >
                <error-messages-block :field="$v.input['amsCustomerDetail.additionalEmail']">
                    <template #emailValidation>
                        {{$t('profile.email.invalid')}}
                    </template>
                    <template #notSameAs>
                        {{ $t('profile.update.error.email.exits') }}
                    </template>
                    <template #blackListDomainsValidation>
                        {{ $t('MSG_NAB205') }}
                    </template>
                    <template #checkChangeToExistingMail>
                        {{ $t('profile.update.error.email.exits') }}
                    </template>
                </error-messages-block>
            </div>
        </div>
        <div class="form-group row">
            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.mail_confirm')}}</label>
            <div class="col-md-6">
                <input type="text"
                       class="form-control"
                       v-model="$v.input['amsCustomerDetail.confirmAdditionalEmail'].$model"
                       name="confirmAdditionalEmail"
                       required
                       maxlength="50"
                       v-remove-fullwidth-character
                       v-keep-only-character
                >
                <error-messages-block :field="$v.input['amsCustomerDetail.confirmAdditionalEmail']">
                    <template #emailValidation>
                        {{$t('profile.email.invalid')}}
                    </template>
                    <template #sameAs>
                        {{ $t('profile.error.mail_confirm.not.matching' ) }}
                    </template>
                </error-messages-block>
            </div>
        </div>
        <template v-if="this.isParentScreenEditProfile">
            <div class="form-action">
                <button class="btn btn-sm btn-submit btn-success mr-2"
                        :disabled="isDisabledButtonSubmit"
                        :type="this.getButtonType()">
                    {{$t('profile.button.submit')}}
                </button>
                <button class="btn btn-default btn-cancel btn-sm"
                        type="button"
                        @click="reverseInput">
                    {{$t('profile.button.cancel')}}
                </button>
            </div>
        </template>
    </ForceNewsBlockWrapper>
</template>
<script>
/**
 * @author HungNS
 */
import formMixin from '@/common/mixins/form';
import {not, sameAs} from 'vuelidate/lib/validators'
import {blackListDomainsValidation, emailValidation} from '@/common/helpers/validation'

export default {
    name: "UpdateAdditionalMail",
    props: {
        hasAdditionEmail: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    mixins: [formMixin],
    methods: {
        additionalEmailKeyUp() {
            if (this.hasAdditionEmail) {
                this.$v.$touch();
            }
        }
    },
    computed: {
        isDisabledButtonSubmit() {
            const {$v} = this;
            const masterInput = this.masterInput;
            const hasNotChangeInput = masterInput && masterInput === JSON.stringify(this.input);
            return $v.$anyError || hasNotChangeInput ||
              !this.hasAdditionEmail && (!this.input['amsCustomerDetail.additionalEmail'] || !this.input['amsCustomerDetail.confirmAdditionalEmail']);
        },
    },
    validations() {
        return {
            input: {
                'amsCustomerDetail.additionalEmail': {
                    emailValidation,
                    notSameAs: not(sameAs(function () {
                        return this.input['amsCustomerDetail.email']
                    })),
                    blackListDomainsValidation,
                    checkChangeToExistingMail: function(){
                        let newAdditionalMail = this.input['amsCustomerDetail.additionalEmail'];
                        let oldMainMail = null;
                        let oldAdditionalMail = null;
                        if (this.isParentScreenForceNew){
                            oldMainMail = this.getForceNewsCustomerInfoView.email;
                            oldAdditionalMail = this.getForceNewsCustomerInfoView.additionalEmail;
                        } else {
                            oldMainMail = JSON.parse(this.masterInput)['amsCustomerDetail.email'];
                            oldAdditionalMail = JSON.parse(this.masterInput)['amsCustomerDetail.additionalEmail'];
                        }
                        return this.checkNonCaseSensitiveExistingEmail(oldAdditionalMail, newAdditionalMail) && this.checkNonCaseSensitiveExistingEmail(oldMainMail, newAdditionalMail);
                    }
                },
                'amsCustomerDetail.confirmAdditionalEmail': {
                    emailValidation,
                    sameAs: sameAs(function () {
                        if (this.hasAdditionEmail || !this.hasAdditionEmail && this.$v.input['amsCustomerDetail.confirmAdditionalEmail'].$anyDirty) {
                            return this.input['amsCustomerDetail.additionalEmail'];
                        }
                    })
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
